import { render, staticRenderFns } from "./lainamarkkina.vue?vue&type=template&id=37e30d88&"
import script from "./lainamarkkina.vue?vue&type=script&lang=js&"
export * from "./lainamarkkina.vue?vue&type=script&lang=js&"
import style0 from "./lainamarkkina.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports